export default __webpack_public_path__ + "static/media/buy_fxdx.f306d934.svg";